import React from 'react';
import ProcessingAnimation from './ProcessingAnimation';

function LoadingOverlay({ show, message = 'Processing…', progress, currentCyclingIcon, showSmallAnimation = false }) {
  if (!show) return null;
  return (
    <div className="loading-overlay" role="status" aria-live="polite">
      <div className="overlay-stack">
        <div className="overlay-content">
          <div className="loading-spinner spinner" aria-hidden="true">
            <svg width="30" height="30" viewBox="0 0 50 50">
              <circle
                cx="25"
                cy="25"
                r="20"
                stroke="currentColor"
                strokeWidth="5"
                fill="none"
                strokeLinecap="round"
                strokeDasharray="31.4 31.4"
              />
            </svg>
          </div>
          <div className="overlay-label">
            <span className="sr-only">{message}</span>
            <span aria-hidden="true">{message}{typeof progress === 'number' ? ` ${progress}%` : ''}</span>
          </div>
        </div>
        <div className="overlay-animation-row" aria-hidden="true">
          <ProcessingAnimation
            isLoading={show}
            currentCyclingIcon={currentCyclingIcon}
            showSmall={showSmallAnimation}
          />
        </div>
      </div>
    </div>
  );
}

export default LoadingOverlay;


